import React from 'react';
import InputAdornment from '@mui/material/InputAdornment';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from '@/ui';

export default function VerifyModal({
  isOpen,
  toggle,
  customVarFlag,
  layoutMissingKeys,
  containerMissingKeys,
  customVariablesNotInContainerLayout,
  fields,
}) {
  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>Missing Keys</ModalHeader>
      <ModalBody>
        {layoutMissingKeys.length > 0 && (
          <>
            <Typography variant='subtitle1' sx={{ mt: 1 }}>
              Layout Missing Keys
            </Typography>
            {layoutMissingKeys.map((key, index) => (
              <TextField
                key={index}
                value={key.key.slice(customVarFlag.length)}
                disabled
                sx={{ my: 0.5 }}
                slotProps={{
                  input: { startAdornment: <InputAdornment position='start'>{customVarFlag}</InputAdornment> },
                }}
              />
            ))}
          </>
        )}
        {containerMissingKeys.length > 0 && (
          <>
            <Typography variant='subtitle1' sx={{ mt: 1 }}>
              Container Missing Keys
            </Typography>
            {containerMissingKeys.map((key, index) => (
              <TextField
                key={index}
                value={key.key?.slice(customVarFlag.length)}
                disabled
                sx={{ my: 0.5 }}
                slotProps={{
                  input: { startAdornment: <InputAdornment position='start'>{customVarFlag}</InputAdornment> },
                }}
              />
            ))}
          </>
        )}
        {customVariablesNotInContainerLayout?.length > 0 && (
          <>
            <Typography variant='subtitle1' sx={{ mt: 1 }}>
              Custom Variables are not in container or layout
            </Typography>
            {customVariablesNotInContainerLayout.map((key, index) => (
              <TextField
                key={index}
                value={key.key?.slice(customVarFlag.length)}
                disabled
                error
                sx={{ my: 0.5 }}
                slotProps={{
                  input: { startAdornment: <InputAdornment position='start'>{customVarFlag}</InputAdornment> },
                }}
              />
            ))}
          </>
        )}
      </ModalBody>
      <ModalFooter>
        {containerMissingKeys.length || layoutMissingKeys.length ? (
          <Button
            color='primary'
            onClick={() => {
              const existingKeys = fields.getAll().map((field) => field.key);
              const combinedKeys = [...containerMissingKeys, ...layoutMissingKeys];
              const uniqueKeys = combinedKeys.filter(
                (key, index, self) =>
                  index === self.findIndex((k) => k.key === key.key && !existingKeys.includes(key.key))
              );

              uniqueKeys.forEach((missingKey) => fields.push(missingKey));
              toggle();
            }}
          >
            Apply
          </Button>
        ) : null}
        <Button color='secondary' onClick={toggle}>
          Close
        </Button>
      </ModalFooter>
    </Modal>
  );
}
